import React from "react";
import WhatsAppButton from "../components/WhatsAppButton.js"; // Import the WhatsAppButton component

const CustomerSupport = () => {
  return (
    <div
      style={{
        // fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", // Clean, modern font

        color: "#333", // Dark text for good readability
        textAlign: "center", // Center content
        padding: "50px 20px", // Add padding for spacing
        minHeight: "100vh", // Full viewport height
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        backgroundColor: "#F5F5F5", // Light background
        fontFamily: "Roboto, sans-serif",
        padding: "30px",
        textAlign: "center",
      }}
    >
      <h1
        style={{
          fontWeight: "600",
          marginBottom: "24px",
          color: "#34495E",
          marginBottom: "20px", // Space below the heading
        }}
      >
        Customer Support
      </h1>
      <p
        style={{
          fontSize: "18px",
          color: "#555", // Lighter gray for the paragraph text
          marginBottom: "40px", // Space below the paragraph
        }}
      >
        If you need assistance, you can chat with us on WhatsApp!
      </p>

      {/* WhatsApp button */}
      <WhatsAppButton />
    </div>
  );
};

export default CustomerSupport;
